const faqItems = [
  {
    id: 1,
    question: '窝窝影院真的完全免费吗？',
    answer:
      '是的，窝窝影院所有影视内容均完全免费在线观看。我们聚合全网优质免费影视资源，涵盖最新电影、热播电视剧、综艺节目、动漫番剧等全品类，无需付费订阅即可畅享全部内容。平台通过技术支持确保流畅的观影体验，让每一位用户都能零成本追剧观影。',
  },
  {
    id: 2,
    question: '观看需要注册账号或下载软件吗？',
    answer:
      '完全不需要。窝窝影院支持直接在线观看，无需注册账号，无需下载任何客户端或插件。打开浏览器即可立即开始观影，简洁高效。我们致力于降低用户的使用门槛，让免费观影回归最简单的形式。无论是电脑、手机还是平板，打开网站就能看。',
  },
  {
    id: 3,
    question: '视频画质怎么样？支持高清播放吗？',
    answer:
      '窝窝影院全线支持高清画质播放，主流影片提供 720P 至 1080P 清晰度选项。我们采用先进的视频加速技术，保障播放流畅不缓冲，同时画面清晰度远超市面上多数同类平台。无论您是使用 WiFi 还是移动数据，都能获得稳定流畅的高清观影体验。',
  },
  {
    id: 4,
    question: '内容更新频率如何？会同步最新剧集吗？',
    answer:
      '窝窝影院坚持每日实时更新，热门影视剧集播出后第一时间同步上线。院线电影下映后迅速入库，综艺节目、动漫番剧紧随播出节奏更新。我们的内容团队全天候监控全网影讯动态，确保您不会错过任何一部精彩作品。每日来窝窝影院，总有新发现。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-100/70">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium tracking-wide mb-3">
            FAQ
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-2 max-w-lg mx-auto">
            关于窝窝影院的常见疑问解答，让您安心观影
          </p>
        </div>

        <div className="space-y-4">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold mt-0.5">
                  Q
                </span>
                {item.question}
              </h3>
              <div className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 text-xs font-bold mt-0.5">
                  A
                </span>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}